<template>
  <v-select
    v-model="template"
    :items="templatesList"
    :label="$t('Template')"
    item-text="name"
    item-value="code"
  />
</template>

<script>
export default {
  name: 'TemplateSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    templates: {
      type: Array,
      required: true
    }
  },

  computed: {
    templatesList () {
      return this.templates.map(template => {
        return {
          name: `${template.name} (${template.code})`,
          code: template.code
        }
      })
    },

    template: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
